/* eslint-disable */
import React, { useState, useEffect, useMemo } from "react";
import { useParams } from "react-router-dom";

// Material UI table
import { MaterialReactTable } from "material-react-table";

//import url and gateway methods
import { getData, putData, postData } from "utils/Gateway";
import * as url from "helper/UrlHelper";

import { createContactChatHandler } from "helper/AppUserHelper/AppUserHelper";

//import components
import AddLabelModal from "components/Common/Modal/AddLabelModal";
import TabsHeader from "components/Common/TabsHeader/TabsHeader";
import { eventDetailsHeaderLinks } from "helper/EventHelper/EventHelper";
import EventQuotationSellHeader from "../Header/EventQuotationSellHeader";
import QuotationSellFilterPopup from "../Popup/QuotationSellFilterPopup";
import { useTranslation } from "react-i18next";

const EventQuotationSellBody = () => {
  const { t, i18n } = useTranslation(); //for translation
  const params = useParams();
  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const moduleAccess = localStorage.getItem("moduleaccess");

  // -------- tabs header object --------------------
  const [isEventModerator, setisEventModerator] = useState(false);
  const [eventMemberStatus, setEventMemberStatus] = useState("");
  const [eventModStatus, setEventModStatus] = useState("");
  const [isEventDetailsLoading, setIsEventDetailsLoading] = useState(false);
  const [parentEventTitle, setParentEventTitle] = useState("");

  const [commonHeaderObject, setCommonHeaderObject] = useState([]);

  const [sellQuotations, setSellQuotations] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [rowSelection, setRowSelection] = useState({});
  const [selectedQuotationIds, setSelectedQuotationIds] = useState([]);

  const [reloadData, setReloadData] = useState(false);
  const [isFilterReset, setIsFilterReset] = useState(false);
  // json filter query
  const [jsonFilterQuery, setJsonFilterQuery] = useState([]);

  //function for get details of event member
  const getMemberDetails = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_EVENT_MEMBER_DETAILS_BY_QUERY +
        `?token=${token}&eventid=${params.id}`;

      const response = await getData(requestUrl);

      console.log("response in member details", response);

      if (response.status) {
        setEventMemberStatus(response.data.memberstatus);
        setEventModStatus(response.data.moderatorstatus);
      } else {
        setAlertMessage(response.message);
        setMessageType("error");
        setShowAlert(true);
      }
    } catch (error) {
      setAlertMessage(error.message);
      setMessageType("error");
      setShowAlert(true);
    }
  };

  //function for get event details
  const getEventDetails = async () => {
    setIsEventDetailsLoading(true);
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_EVENT_DETAILS +
        `/${params.id}?token=${token}&modulefrom=common`;

      console.log("url of event details------>", requestUrl);

      const response = await getData(requestUrl);

      console.log("response of event details------>", response);

      if (response.status) {
        //assign title
        response.data?.title && setParentEventTitle(response.data?.title);

        // Assign slug and update header links
        response.data?.slug && setEventSlug(response.data?.slug);

        let isModerator = false;

        if (
          response.data.moderator._id.toString() === userInfo._id.toString() ||
          userInfo.role.slug === "ADMIN" ||
          userInfo.role.slug === "SUPER_ADMIN"
        ) {
          isModerator = true;
        } else {
          getMemberDetails();
        }

        setisEventModerator(isModerator);

        setIsEventDetailsLoading(false);

        setCommonHeaderObject(
          eventDetailsHeaderLinks(
            params.id,
            t,
            response.data?.eventtype?.slug,
            isModerator
          )
        );
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  // Function to fetch quotations of type "sell"
  const fetchSellQuotations = async () => {
    try {
      setIsLoading(true);
      let requestURL =
        url.API_BASE_URL +
        url.API_GET_ALL_QUOTATIONS +
        `?token=${token}&eventid=${params.id}&type=sell`;

      const response = await getData(requestURL);

      console.log("fetchSellQuotations response:", response);

      setIsLoading(false);
      if (response.status) {
        setSellQuotations(response.data);
      }
    } catch (error) {
      console.log(error.message);
      setIsLoading(false);
    }
  };

  const getSellQuotationsByFilter = async () => {
    try {
      setIsLoading(true);
      let requestURL =
        url.API_BASE_URL + url.API_GET_FILTERED_QUOTATIONS + `?token=${token}`;

      const typeQuery = {
        field: "type",
        operator: "contains",
        value: "sell",
      };

      const eventQuery = {
        field: "event",
        operator: "includes",
        value: params.id,
      };

      console.log("Original jsonFilterQuery:", jsonFilterQuery);

      const appendedQuery = [...jsonFilterQuery, typeQuery, eventQuery];

      // Sanitize the jsonFilterQuery
      const sanitizedQuery = appendedQuery.map((filter) => {
        if (
          (filter.operator === "includes" || filter.operator === "excludes") &&
          Array.isArray(filter.value)
        ) {
          return {
            ...filter,
            value: filter.value.map((item) => item.value).join(","), // Extract and join values as a comma-separated string
          };
        }
        return filter;
      });

      console.log("Sanitized jsonFilterQuery:", sanitizedQuery);

      const filterData = {
        filters: sanitizedQuery,
      };

      const response = await postData(requestURL, filterData);

      console.log("json filter query response ------->", response);

      setIsLoading(false);
      if (response.status) {
        setSellQuotations(response.data);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  // Function to handle status change (e.g., delete quotations)
  const changeStatusHandler = async () => {
    if (selectedQuotationIds.length > 0) {
      try {
        let requestUrl =
          url.API_BASE_URL + url.API_DELETE_QUOTATION + `?token=${token}`;

        const response = await putData(requestUrl, {
          quotationIds: selectedQuotationIds,
        });

        if (response.status) {
          fetchSellQuotations();
        }
      } catch (error) {
        console.log(error.message);
      }
    } else {
      console.log("No quotations selected.");
    }
  };

  //reset filter
  const resetFilterData = () => {
    setRowSelection({});
    setSelectedQuotationIds([]);
    setJsonFilterQuery([]);
    setIsFilterReset(true);
    setReloadData(true);
  };

  useEffect(() => {
    if (jsonFilterQuery.length > 0) {
      getSellQuotationsByFilter();
    }
  }, [jsonFilterQuery]);

  useEffect(() => {
    if (reloadData) {
      fetchSellQuotations();
      setReloadData(false);
    }
  }, [reloadData]);

  useEffect(() => {
    const selectedIdsArray = Object.keys(rowSelection).filter(
      (key) => rowSelection[key]
    );

    if (selectedIdsArray.length > 0) {
      setSelectedQuotationIds(selectedIdsArray);
    } else {
      setSelectedQuotationIds([]);
    }
  }, [rowSelection]);

  useEffect(() => {
    if (params.id) {
      getEventDetails();
      fetchSellQuotations();
    }
  }, [params.id]);

  const columns = useMemo(
    () => [
      {
        accessorKey: "#",
        header: t("Actions"),

        Cell: ({ row }) => {
          if (row.original.role === "Moderator") {
            return (
              <button className="action_btn_mui">
                <span className="d-block material-symbols-outlined horz_icon">
                  more_horiz
                </span>
              </button>
            );
          } else {
            return (
              <button
                className="action_btn_mui"
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasMemberDetails"
                aria-controls="offcanvasMemberDetails"
                onClick={() => {
                  setQuotationId(row.original._id);
                }}
              >
                <span className="d-block material-symbols-outlined horz_icon">
                  more_horiz
                </span>
              </button>
            );
          }
        },
        enableColumnActions: false, // Hides the column action icon
        enableColumnDragging: false, // Hides the move icon
        enableSorting: false,
      },
      {
        accessorKey: "customid",
        header: t("Id"),
      },
      {
        accessorKey: "tagstring",
        header: t("Tags"),
        Cell: ({ row }) => {
          const tags = row.original.tags || [];
          return (
            <div className="label border-bottom-0">
              {tags && (
                <ul className="d-flex flex-wrap gap-2 fs-xs">
                  {tags.map((tag, index) => {
                    return (
                      <li
                        key={index}
                        className="px-2 py-1 gradient-light rounded-5"
                      >
                        {tag.title}
                      </li>
                    );
                  })}
                </ul>
              )}
            </div>
          );
        },
      },
      {
        accessorKey: "provider.name",
        header: t("Provider"),
        Cell: ({ row }) => (
          <div className="d-flex align-items-center justify-content-between">
            <span>
              {`${row.original.provider?.name ?? ""} ${
                row.original.provider?.surname ?? ""
              }`}
            </span>
            <button
              onClick={() => {
                createContactChatHandler(
                  row.original.provider._id,
                  "MOD_EVENT",
                  params.id,
                  parentEventTitle
                );
              }}
              className="d-flex align-items-center ms-auto border-0 bg-light"
            >
              <span className="d-block material-symbols-outlined icon-md text-primary">
                chat
              </span>
            </button>
          </div>
        ),
      },
      {
        accessorKey: "product.name",
        header: t("Product"),
        Cell: ({ row }) => row.original.product?.name || "",
      },
      {
        accessorKey: "units",
        header: t("Units"),
      },
      {
        accessorKey: "price",
        header: t("Price"),
        Cell: ({ row }) => `€${row.original.totalprice}`,
      },
      {
        accessorKey: "process",
        header: t("Process"),
      },
      {
        accessorKey: "payment",
        header: t("Payment"),
        Cell: ({ row }) => (row.original.payment ? "Paid" : "Unpaid"),
      },
      {
        accessorKey: "createdAt",
        header: t("Submitted On"),
        Cell: ({ row }) => {
          const date = new Date(row.original.createdAt);
          const day = String(date.getUTCDate()).padStart(2, "0");
          const month = String(date.getUTCMonth() + 1).padStart(2, "0"); // Months are 0-based
          const year = date.getUTCFullYear();
          return `${day}/${month}/${year}`; // Ensure the format is dd/mm/yyyy
        },
      },
    ],
    [t]
  );

  const initialColumnOrder = [
    "#",
    "mrt-row-select",
    ...columns.map((c) => c.accessorKey),
  ]; //array of column ids (Initializing is optional as of v2.10.0)

  return (
    <div id="content_wrapper">
      <section className="event-details-wrapper bg-white pb-5">
        {/* ---- common header ---- */}
        <TabsHeader
          commonHeaderObject={commonHeaderObject}
          activeOption={t("Sell Quotations")}
        />
        <div className="container-fluid px-lg-5 pt-4 pt-md-0">
          <EventQuotationSellHeader
            reloadQuotations={resetFilterData}
            isEventModerator={isEventModerator}
            changeStatusHandler={changeStatusHandler}
          />

          {isLoading ? (
            <div className="placeholder-glow d-flex flex-column gap-4">
              <span className="placeholder placeholder-lg bg-secondary col-12"></span>
              <span className="placeholder placeholder-lg bg-secondary col-8"></span>
              <span className="placeholder placeholder-lg bg-secondary col-4"></span>
            </div>
          ) : (
            <div className="table-wrapper">
              <MaterialReactTable
                columns={columns}
                data={sellQuotations}
                enableGrouping // to enable grouping of column
                enableRowSelection // enable showing checkbox
                getRowId={(row) => row._id} // map which value to select with row checkbox
                onRowSelectionChange={setRowSelection} //connect internal row selection state to your own
                state={{ rowSelection, columnOrder: initialColumnOrder }} //pass our managed row selection state to the table to use
                initialState={{
                  rowSelection,
                  columnOrder: initialColumnOrder,
                }}
                defaultColumn={{
                  minSize: 20,
                  maxSize: 300,
                  size: 50, //make columns wider by default
                }}
                muiTableContainerProps={{
                  sx: {
                    maxHeight: "60vh",
                  },
                }}
                enableStickyHeader
              />
            </div>
          )}
        </div>
      </section>

      {/* Add Label Modal */}
      <AddLabelModal
        moduleName="quotation"
        afterTagModalClose={resetFilterData}
        selectedIds={selectedQuotationIds}
      />

      {/* Offcanvas for member details */}
      <QuotationSellFilterPopup
        setJsonFilterQuery={setJsonFilterQuery}
        reloadList={resetFilterData}
        moduleSlug="quotationsell"
        isFilterReset={isFilterReset}
        setIsFilterReset={setIsFilterReset}
      />
    </div>
  );
};

export default EventQuotationSellBody;
